import React, { Component } from 'react';
const canUseDOM = !!(
  (typeof window !== 'undefined' &&
    window.document && window.document.createElement)
);

export default class Customerly extends Component {
  static displayName = 'Customerly';

  constructor(props) {
    super(props);

    const {
      appID,
    } = props;
    if (!appID || !canUseDOM) {
      return;
    }

    if (!window.customerlySettings) {
      window.customerlySettings = {
        app_id: appID,
      };
      function e(){
        const e = t.createElement('script');
        e.type = 'text/javascript';
        e.setAttribute('crossorigin', '*');
        e.async = 1;
        e.src = `https://widget.customerly.io/widget/${appID}`;
        document.head.appendChild(e);
      }
      const r = window;
      const t = document;
      const n = function () { n.c(arguments) };
      r.customerly_queue = [];
      n.c = function (e) {
        r.customerly_queue.push(e);
      };
      r.customerly = n;
      e();
    } else {
      window.customerly("show");
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    if (!canUseDOM || !window.customerly) return false;
    window.customerly("hide");
  }

  render() {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/customerly/Customerly.js